<template>
  <router-view />
</template>


<script>
/* @flow */
export default {
  name: 'AppWrapper',
}
</script>

<style lang="stylus">
</style>

<style>
@import './styles/vuetify-overrides.css';

.v-application {
    font-family: 'Open Sans',sans-serif;
    line-height: 1.5;
}

.bg-white {
  background-color: #fff !important;
}
.bg-primary {
  background-color: #0072ce !important;
}
.bg-clear {
  background-color: rgba(0, 0, 0, 0) !important;
}
.bg-dark {
  background-color: #21262a !important;
}
.bg-light-gray {
  background-color: #dee1e3 !important;
}
.black-text {
  color: #374047 !important;
}
.light-black-text {
  color: #6c7884 !important;
}
.primary-text {
  color: #0072ce !important;
}
.secondary-text {
  color: #707372 !important;
}
.accent-text {
  color: #40c1ac !important;
}
.success-text {
  color: #0cba00 !important;
}
.warning-text {
  color: #eaaa00 !important;
}
.error-text {
  color: #d22630 !important;
}
.navy-text {
  color: #00216c !important;
}
.purple-text {
  color: #9e007e !important;
}
.lime-text {
  color: #bfb800 !important;
}
.gold-text {
  color: #eaaa00 !important;
}
.pointer {
  cursor: pointer;
}

.monospace {
  font-family: Consolas, monospace;
}
.medium {
  font-weight: 600 !important;
}

.allcaps {
  text-transform: uppercase;
  letter-spacing: 0.1em;
}
.nogrow {
  flex-grow: 0;
}
.noshrink {
  flex-shrink: 0;
}

.animated.fast {
  animation-duration: 0.1s;
}
.animated.semi-fast {
  animation-duration: 0.2s;
}

.animated-loading-background {
  background: #ecedef;
  border-radius: 3px;
  position: relative;
  overflow: hidden;
}

.animated-loading-background:after {
  animation-duration: 2.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  content: '';
  background: linear-gradient(
    to right,
    #ecedef 0%,
    #ecedef 40%,
    #dee1e3 70%,
    #ecedef 100%
  );
  background-size: 300px 300px;
  height: 100%;
  width: 300px;
  position: absolute;
}

@keyframes placeHolderShimmer {
  0% {
    transform: translateX(-330px);
  }
  100% {
    transform: translateX(300px);
  }
}
</style>



// WEBPACK FOOTER //
// src/AppWrapper.vue